<template>
    <svg 
      :style=" {width: `${width}px`, height: `${height}px` }"
      class="svg-icon"
      aria-hidden="true">
      <use :xlink:href="`#${type}`"></use>
    </svg>
</template>

<script>
import '../assets/fonts/iconfont'

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '',
    },
    height: {
      type: [String, Number],
      default: '',
    }
  }
}
</script>

<style lang="scss">
.svg-icon {
  width: 1em; height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>

